import {
  logDebug
} from "../chunk-KTPUX2XH.js";

// lib/router/printer.ts
var printRouterTreeFn = (items, level) => {
  items.forEach((item) => {
    logDebug(
      "[Router Tree]",
      Array(2 * level).fill(" ").join("|"),
      item.path
    );
    if (item.children !== void 0) {
      printRouterTreeFn(item.children, level + 1);
    }
  });
};
var printRouterTree = (items) => printRouterTreeFn(items, 0);
export {
  printRouterTree
};
